import {salesMail} from 'config'

let investorAccessDenied = `Investors doesn't have access to buy a domain, Please contact admin ` + salesMail

const errorMessages = {
    accessDenied: "You dont have a permission to perform this action",
    passwordMustMatch: "Password and Confirm password should match",
    dontHaveDomainName: "You dont have a domain name to checkout",
    continueServiceWithDomainName: "Please enter a domain name to continue with our brokerage services",
    domainWithoutExtension: "The domain name needs to have an extension and no special character",
    invalidEmail: "Email is not valid, Please enter valid email address",
    historyNotFound: "No search history found!",
    notAllowed: "You are not allowed to do this action, please contact admin",
    loginAsUser: "Please login as user to continue this action",
    invalidDomain: "Please enter valid domain",
    investorAccessDenied,
    domainNotValid: "Not a valid domain",
    emptyPromoCode: "Please enter promo code and should be 6 character",
    unSupportedExtensionShortMsg: "We only support Com, Net, Org, Xyz, Co, Io, and Ca extensions for now",
    passwordInvalidContent: "Password must have a minimum length of 8 characters containing at least one number, an uppercase, and a special character",
    passwordMissing: "Please enter valid password",
    enterBelow100: "Please Enter less then 100",
    commissionBelow100: "Please enter commission percent less then 100",
    reachedAppraisalLimit: "You have reached maximum appraisal limit today!",
    alternateDomainLimit: 'You have reached your domain search limit, please contact support',
    invalidPromo: "Please enter valid promo code",
    leadDetailNotLoaded: "Lead detail is not found, Please refresh the page and try again",
    commentsNotFoundError: "Please leave the comments",

}
export default errorMessages
